import React from 'react';
import { IView } from 'interfaces/common';
import { IRoles } from 'interfaces/roles.interface';

const ViewUserAssignSuperior: IView = {
  key: 'viewUserAssignSuperior',
  title: 'tasks.taskCreation.taskBase',
  roles: [IRoles.ADMINISTRATOR, IRoles.HR],
  view: React.lazy(() => import('./assign-superior-page')),
  path: '/pracownicy/przelozony/:id',
};

export default ViewUserAssignSuperior;
